import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Fab from '@mui/material/Fab';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDateTimePicker, MobileDateTimePicker } from '@mui/x-date-pickers';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ReloadButton from './ReloadButton';
import './ListOfThumbnails.css';
import syncCloudIcon from './assets/sync_cloud.svg';

const theme = createTheme({
  palette: {
    lightGreen: { main: '#8bc34a', contrastText: '#fff', hover: { backgroundColor: '#2e7d32' } },
    darkGreen: { main: '#328555', contrastText: '#fff' },
    grey: { 200: '#eeeeee', 300: '#e0e0e0', 500: '#9e9e9e', 700: '#616161' }
  },
});

const MAX_THUMBNAILS = 8;

class ListOfThumbnails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedThumbnails: [],
      rotationIntervalPreset: 5,
      customRotationInterval: '',
      rotationNumber: 20,
      selectedDate: null,
      isSchedulerVisible: false,
      schedulerStep: 1,
      tempSelectedDate: null,
      SelectedVideo: null,
      pollingInterval: null,
      isStartingRotation: false,
    };
    this.fileInputRef = React.createRef();
  }

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
    selectedVideo: instanceOf(Object),
    video_ID: instanceOf(String),
    thumbnail: instanceOf(String),
    archiveValue: instanceOf(Number),
    loadStatuses: instanceOf(Function).isRequired,
    refreshAllVideoData: instanceOf(Function).isRequired,
  };

  componentDidMount() {
    this.loadVideoDetailsIfNeeded(this.props.selectedVideo, this.props.archiveValue);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedVideo !== prevProps.selectedVideo || this.props.archiveValue !== prevProps.archiveValue) {
      if (this.props.selectedVideo !== prevProps.selectedVideo) {
         this.clearSetupState();
      }
      this.loadVideoDetailsIfNeeded(this.props.selectedVideo, this.props.archiveValue);
    }
    if (!this.props.selectedVideo && prevProps.selectedVideo) {
        this.clearSetupState();
        this.setState({ SelectedVideo: null });
    }

    if (prevState.SelectedVideo?.status !== this.state.SelectedVideo?.status) {
        const shouldPoll = this.state.SelectedVideo && (this.state.SelectedVideo.status === 'ROTATING' || this.state.SelectedVideo.status === 'SCHEDULED' || this.state.SelectedVideo.status === 'SYNCHRONIZATION');
        const isPolling = this.state.pollingInterval !== null;

        if (shouldPoll && !isPolling) {
            const pollingId = setInterval(() => {
                this.loadVideoDetailsIfNeeded(this.props.selectedVideo, this.props.archiveValue);
            }, 5000);
            this.setState({ pollingInterval: pollingId });
        } else if (!shouldPoll && isPolling) {
            clearInterval(this.state.pollingInterval);
            this.setState({ pollingInterval: null });
        }
    }
  }

  componentWillUnmount() {
    if (this.state.pollingInterval) {
      clearInterval(this.state.pollingInterval);
    }
  }

  clearSetupState = () => {
    this.setState({
        uploadedThumbnails: [],
        rotationIntervalPreset: 5,
        customRotationInterval: '',
        rotationNumber: 20,
        selectedDate: null,
        isSchedulerVisible: false,
        schedulerStep: 1,
        tempSelectedDate: null,
        isStartingRotation: false,
    });
  }

  loadVideoDetailsIfNeeded = (selectedVideoProps, archiveValue) => {
    if (!selectedVideoProps || !selectedVideoProps.video_ID) {
        this.setState({ SelectedVideo: null });
        return;
    }

    let url;
    let requestInput;

    if (archiveValue !== null && archiveValue !== undefined) {
        url = `/api/videos/getPreviousVideoRotation`;
        requestInput = {
             method: 'GET',
             headers: new Headers({
               video_ID: selectedVideoProps.video_ID,
               code: this.props.cookies.get('code'),
               previousVideoIndex: archiveValue,
             }),
           };
    } else {
        url = `/api/videos/scheduledVideo`;
        requestInput = {
             method: 'GET',
             headers: new Headers({
               video_ID: selectedVideoProps.video_ID,
               code: this.props.cookies.get('code'),
             }),
           };
    }

    fetch(url, requestInput)
      .then((res) => {
          if (!res.ok) {
              console.error(`HTTP error! status: ${res.status} for ${url}`);
          }
          return res.json();
      })
      .then((data) => {
        console.log(`Data received for video ID ${selectedVideoProps.video_ID}, archive value ${archiveValue}:`, data);

        let videoData = null;
        if (archiveValue !== null && archiveValue !== undefined) {
             if (data) {
                 const uploadedThumbnails = Array.isArray(data.uploadedThumbnails) ? data.uploadedThumbnails : [];
                 videoData = { ...data, uploadedThumbnails, isArchived: true };
             } else {
                 videoData = { video_ID: selectedVideoProps.video_ID, isArchived: true, uploadedThumbnails: [] };
             }

        } else {
            if (data && data.scheduledVideos) {
                videoData = { ...data.scheduledVideos, isArchived: false };
            } else {
                 videoData = { video_ID: selectedVideoProps.video_ID, isArchived: false, status: 'NONE', uploadedThumbnails: [] };
            }
        }

        this.setState({ SelectedVideo: videoData });

      })
      .catch(error => {
          console.error(`Error fetching video details for video ID ${selectedVideoProps.video_ID} with archive value ${archiveValue}:`, error);
          this.setState({ SelectedVideo: { video_ID: selectedVideoProps.video_ID, isArchived: false, status: 'ERROR', uploadedThumbnails: [] } });
      });
  };

  handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    this.processFiles(files);
    event.target.value = null;
  };

  handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const files = Array.from(event.dataTransfer.files);
    this.processFiles(files);
  };

  processFiles = (files) => {
    const newThumbnails = [...this.state.uploadedThumbnails];
    files.forEach(file => {
      if (file.size > 2 * 1024 * 1024) {
        alert(`File ${file.name} is too large. Maximum size is 2MB.`);
        return;
      }
      if (newThumbnails.length < MAX_THUMBNAILS && file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          newThumbnails.push({ image: reader.result, imageName: file.name, fileObject: file });
          if (newThumbnails.length <= MAX_THUMBNAILS) {
             this.setState({ uploadedThumbnails: newThumbnails });
          }
        };
        reader.readAsDataURL(file);
      }
    });
  };

  removeThumbnail = (index) => {
    const newThumbnails = [...this.state.uploadedThumbnails];
    newThumbnails.splice(index, 1);
    this.setState({ uploadedThumbnails: newThumbnails });
  };

  triggerFileInput = () => {
    if (this.fileInputRef.current) {
        this.fileInputRef.current.click();
    }
  };

  handleRotationIntervalPreset = (minutes) => {
    this.setState({ rotationIntervalPreset: minutes, customRotationInterval: '' });
  };

  handleCustomIntervalChange = (event) => {
    this.setState({ customRotationInterval: event.target.value, rotationIntervalPreset: null });
  };

  handleRepeatChange = (event) => {
    this.setState({ rotationNumber: event.target.value });
  };

  openScheduler = () => this.setState({ isSchedulerVisible: true, schedulerStep: 1, tempSelectedDate: dayjs() });
  closeScheduler = () => this.setState({ isSchedulerVisible: false, schedulerStep: 1, tempSelectedDate: null });
  
  handleScheduleDateChange = (newValue) => {
    this.setState({ tempSelectedDate: newValue });
  };

  handleSchedulerNext = () => {
    this.setState({ schedulerStep: 2 });
  };
  
  handleSchedulerSet = () => {
    this.setState({ selectedDate: this.state.tempSelectedDate, isSchedulerVisible: false, schedulerStep: 1 });
  };

  handleStartRotationClick = () => {
    if (!this.props.selectedVideo || !this.props.selectedVideo.video_ID) {
        console.error("No video selected");
        return;
    }
    let rotationOffset = this.state.selectedDate ? this.state.selectedDate.valueOf() - Date.now() : 0;
    if (rotationOffset < 0 && this.state.selectedDate) rotationOffset = 0;

    const preparedUploadedThumbnails = this.state.uploadedThumbnails.map(t => ({ image: t.image, imageName: t.imageName }));

    const finalRotationMinutes = this.state.customRotationInterval 
        ? parseInt(this.state.customRotationInterval, 10) 
        : this.state.rotationIntervalPreset;

    if (isNaN(finalRotationMinutes) || finalRotationMinutes <= 0) {
        alert("Please set a valid rotation interval.");
        return;
    }
    if (preparedUploadedThumbnails.length < 2) {
        alert("Please upload at least two thumbnails to compare.");
        return;
    }

    this.setState({ isStartingRotation: true });

    const requestInput = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        video_ID: this.props.selectedVideo.video_ID,
        thumbnail: this.props.selectedVideo.thumbnail,
        code: this.props.cookies.get('code'),
      }),
      body: JSON.stringify({
        video_ID: this.props.selectedVideo.video_ID,
        uploadedThumbnails: preparedUploadedThumbnails,
        rotationNumber: parseInt(this.state.rotationNumber, 10) || 1,
        rotationMinutes: finalRotationMinutes,
        rotationOffset: rotationOffset,
        selectedDate: this.state.selectedDate ? this.state.selectedDate.valueOf() : null,
      }),
    };

    const url = `/api/videos/scheduleVideo`;

    fetch(url, requestInput)
      .then((res) => res.json())
      .then((data) => {
        console.log('Rotation scheduled/started: ', data);
        this.props.refreshAllVideoData(); 
        this.loadVideoDetailsIfNeeded(this.props.selectedVideo, null);
      })
      .catch((error) => {
        console.error('Error starting/scheduling rotation:', error);
        alert('Failed to start/schedule rotation.');
      })
      .finally(() => {
        this.setState({ isStartingRotation: false });
      });
  };

  calculateEstimatedDuration = () => {
    const numThumbnails = this.state.uploadedThumbnails.length;
    const interval = this.state.customRotationInterval ? parseInt(this.state.customRotationInterval) : this.state.rotationIntervalPreset;
    const repeats = parseInt(this.state.rotationNumber);
    if (numThumbnails < 2 || !interval || !repeats || interval <= 0 || repeats <=0) return "N/A";
    const totalMinutes = numThumbnails * interval * repeats;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `about ${hours > 0 ? hours + ' hour' + (hours > 1 ? 's' : '') : ''} ${minutes > 0 ? minutes + ' minute' + (minutes > 1 ? 's' : '') : ''}`.trim() || "0 minutes";
  };

  handleNextRotationClick = () => {
    console.log("Next Rotation clicked");
      const requestInput = {
        method: 'GET',
        headers: new Headers({
          video_ID: this.props.selectedVideo.video_ID,
          code: this.props.cookies.get('code'),
        }),
      };

      const url = `/api/videos/archive`;

      fetch(url, requestInput)
        .then((res) => res.json())
        .then((data) => {
          console.log('Rotation archived: ', data);
          this.props.refreshAllVideoData(); 
          this.loadVideoDetailsIfNeeded(this.props.selectedVideo, null);
        })
        .catch((error) => {
          console.error('Error archiving rotation:', error);
          alert('Failed to archive rotation.');
        });
  };

  handleStopRotationClick = () => {
    const requestInput = {
      method: 'GET',
      headers: new Headers({
        video_ID: this.props.selectedVideo.video_ID,
        code: this.props.cookies.get('code'),
      }),
    };

    const url = `/api/videos/stopRotation`;

    fetch(url, requestInput)
      .then((res) => res.json())
      .then((data) => {
        console.log('Rotation stopped: ', data);
        this.props.refreshAllVideoData();
        this.loadVideoDetailsIfNeeded(this.props.selectedVideo, null);
      })
      .catch((error) => {
        console.error('Error stopping rotation:', error);
        alert('Failed to stop rotation.');
      });
  };

  handleYoutubeAnalyticsClick = () => {
    if (this.props.selectedVideo && this.props.selectedVideo.video_ID) {
        const youtubeAnalyticsUrl = `https://studio.youtube.com/video/${this.props.selectedVideo.video_ID}//analytics/tab-overview/period-default/explore?entity_type=VIDEO&entity_id=${this.props.selectedVideo.video_ID}&time_period=since_publish&explore_type=LATEST_ACTIVITY`;
        window.open(youtubeAnalyticsUrl, '_blank');
    } else {
        console.error("No video selected to view analytics.");
    }
  };

  render() {
    const { uploadedThumbnails, rotationIntervalPreset, customRotationInterval, rotationNumber, selectedDate, isSchedulerVisible, schedulerStep, tempSelectedDate, SelectedVideo, isStartingRotation } = this.state;
    const { selectedVideo: selectedVideoProps, archiveValue } = this.props;

    if (!selectedVideoProps) {
        return (
             <ThemeProvider theme={theme}>
                <Box className="lot-status-view no-video-selected">
                     <Typography variant="h6">No video selected</Typography>
                     <Typography>Please select a video from the list on the left to view details or set up a rotation.</Typography>
                </Box>
             </ThemeProvider>
        );
    }

    if (SelectedVideo) {
        if (SelectedVideo.status === 'SYNCHRONIZATION') {
             return (
                <ThemeProvider theme={theme}>
                    <Box className="lot-status-view lot-sync-view">
                        <Typography variant="h6">Synchronization in Progress</Typography>
                        <img src={syncCloudIcon} alt="Synchronization" className="lot-sync-icon" />
                        <Typography>Please wait while we synchronize with YouTube.</Typography>
                        <Box sx={{ mt: 2 }}>
                            <Button variant="outlined" onClick={() => { this.loadVideoDetailsIfNeeded(selectedVideoProps, archiveValue) }} sx={{ mr: 2 }}>Refresh Status</Button>
                            <Button variant="outlined" color="error" onClick={this.handleStopRotationClick}>Stop Rotation</Button>
                        </Box>
                    </Box>
                </ThemeProvider>
            );
        } else if (SelectedVideo.isArchived || ['FINISHED', 'ROTATING', 'SCHEDULED', 'CANCELED', 'FAILED'].includes(SelectedVideo.status)) {
            const resultsVariants = SelectedVideo.uploadedThumbnails || [];
            const rotationsLeft = SelectedVideo.rotationNumber - (SelectedVideo.rotationCycleNumber || 0);

            let title = 'Results';
            if (SelectedVideo.isArchived) {
                title = 'Archived Results';
            } else if (SelectedVideo.status === 'ROTATING') {
                title = 'Rotation in Progress';
            } else if (SelectedVideo.status === 'SCHEDULED') {
                title = 'Rotation Scheduled';
            }

            let globalStart = null;
            let globalEnd = null;

            if (resultsVariants && resultsVariants.length > 0) {
                resultsVariants.forEach(variant => {
                    if (variant.rotationTimestamp && variant.rotationTimestamp.length > 0) {
                        variant.rotationTimestamp.forEach(rot => {
                            const start = dayjs(rot.start);
                            const end = dayjs(rot.end);
                            if (!globalStart || start.isBefore(globalStart)) globalStart = start;
                            if (!globalEnd || end.isAfter(globalEnd)) globalEnd = end;
                        });
                    }
                });
            }

            return (
                <ThemeProvider theme={theme}>
                    <Box className="lot-results-view">
                         <Typography variant="h6" className="lot-results-title">{title}</Typography>
                         
                         {globalStart && globalEnd && (
                             <Box sx={{ mb: 2, display: 'flex', gap: 4, padding: '12px', backgroundColor: '#fff', borderRadius: 2, border: '1px solid #eee' }}>
                                 <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                     <strong>Start Date:</strong> {globalStart.format('DD MMM YYYY, h:mm:ss A')}
                                 </Typography>
                                 <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                     <strong>End Date:</strong> {globalEnd.format('DD MMM YYYY, h:mm:ss A')}
                                 </Typography>
                             </Box>
                         )}
                         
                         {(SelectedVideo.status === 'SCHEDULED' || SelectedVideo.status === 'ROTATING') && (
                             <Box sx={{ mb: 3, p: 2, backgroundColor: '#f9f9f9', borderRadius: 2, textAlign: 'center' }}>
                                 <Typography>Video: {selectedVideoProps.name}</Typography>
                                 <Typography>Status: {SelectedVideo.status}</Typography>
                                 {SelectedVideo.status === 'SCHEDULED' && SelectedVideo.selectedDate && (
                                     <Typography>Scheduled for: {dayjs(SelectedVideo.selectedDate).format('h:mm A on DD MMM, YYYY')}</Typography>
                                 )}
                                 <Button variant="outlined" color="error" onClick={this.handleStopRotationClick} sx={{ mt: 2 }}>Stop Rotation</Button>
                             </Box>
                         )}

                         {SelectedVideo.isArchived && SelectedVideo.rotationTimestamp && SelectedVideo.rotationTimestamp.length > 0 && (
                              <Typography variant="subtitle2" gutterBottom>Rotation started: {dayjs(SelectedVideo.rotationTimestamp[0].start).format('h:mm A on DD MMM, YYYY')}</Typography>
                         )}

                        <Box className="lot-results-list" sx={{ maxHeight: '65vh', overflowY: 'auto', flexGrow: 1, pr: 1 }}>
                            {resultsVariants.length > 0 ? (
                                resultsVariants.map((variantResult, index) => {
                                    let totalViews = 0;
                                    if (variantResult.viewsArray) {
                                        variantResult.viewsArray.forEach(viewObj => {
                                            if (viewObj && viewObj.end > 0 && viewObj.start !== undefined) {
                                                totalViews += (viewObj.end - viewObj.start);
                                            }
                                        });
                                    }

                                    return (
                                    <Paper key={index} elevation={0} className="lot-result-item">
                                        <img src={variantResult.image} alt={variantResult.imageName} className="lot-result-thumbnail" />
                                        
                                        <Box className="lot-total-views-container">
                                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#555' }}>Total Views</Typography>
                                            <Typography variant="h6" className="lot-result-views" sx={{ mt: '0 !important' }}>👁️ {totalViews}</Typography>
                                        </Box>

                                        <Box className="lot-rotation-details-container">
                                            {variantResult.rotationTimestamp && variantResult.rotationTimestamp.length > 0 ? (
                                                variantResult.rotationTimestamp.map((rotation, rotationIndex) => (
                                                    <Box key={rotationIndex} className="lot-rotation-instance">
                                                        <Typography variant="caption">From: {dayjs(rotation.start).format('h:mm A')}</Typography>
                                                        <Typography variant="caption">To: {dayjs(rotation.end).format('h:mm A')}</Typography>
                                                        {variantResult.viewsArray && variantResult.viewsArray[rotationIndex] && (variantResult.viewsArray[rotationIndex].end > 0) && (
                                                             <Typography variant="body2" className="lot-result-views">👁️ {variantResult.viewsArray[rotationIndex].end - variantResult.viewsArray[rotationIndex].start}</Typography>
                                                        )}
                                                    </Box>
                                                ))
                                            ) : (
                                                 <Typography variant="caption">No rotation data</Typography>
                                            )}
                                        </Box>
                                    </Paper>
                                    );
                                })
                            ) : (
                                 <Typography>No results available for this rotation.</Typography>
                            )}
                        </Box>

                        <Box className="lot-results-actions">
                             {!SelectedVideo.isArchived && <Typography variant="body2" className="lot-rotations-left">{rotationsLeft} Rotations left</Typography>}
                             
                             {!SelectedVideo.isArchived && ['FINISHED', 'CANCELED', 'FAILED'].includes(SelectedVideo.status) && (
                                  <Button
                                      variant="contained"
                                      onClick={this.handleNextRotationClick} 
                                      className="lot-next-rotation-btn"
                                  >
                                      Next Rotation Setup
                                  </Button>
                             )}
                            <Button variant="outlined" onClick={this.handleYoutubeAnalyticsClick} className="lot-youtube-analytics-btn">
                                <img src="https://www.gstatic.com/youtube/img/branding/favicon/favicon_144x144.png" alt="YouTube icon" style={{ width: 20, marginRight: 8 }} />
                                Youtube Analytics
                            </Button>
                        </Box>
                    </Box>
                </ThemeProvider>
            );

        } else if (SelectedVideo.status === 'ERROR') {
              return (
                 <ThemeProvider theme={theme}>
                    <Box className="lot-status-view no-video-selected">
                         <Typography variant="h6">Could not load rotation data.</Typography>
                         <Button variant="outlined" onClick={() => { this.loadVideoDetailsIfNeeded(selectedVideoProps, archiveValue) }}>Retry Loading Data</Button>
                     </Box>
                    </ThemeProvider>
             );

        } else {
            const rotationIntervals = [5, 10, 15, 30, 45, 60, 90, 120];
            const estimatedDuration = this.calculateEstimatedDuration();

            return (
              <ThemeProvider theme={theme}>
                <Box className="lot-setup-panel">
                  <Paper elevation={0} className="lot-paper-section lot-upload-section">
                    <Typography variant="subtitle1" gutterBottom className="lot-section-title">Add thumbnails to compare</Typography>
                    <Box 
                      className="lot-dropzone"
                      onDragOver={(e) => e.preventDefault()} 
                      onDrop={this.handleDrop}
                      onClick={this.triggerFileInput}
                    >
                            <input
                        type="file" 
                              multiple
                        accept=".jpg,.jpeg,.png" 
                        style={{ display: 'none' }} 
                        ref={this.fileInputRef} 
                        onChange={this.handleFileSelect} 
                      />
                      <CloudUploadIcon className="lot-dropzone-icon" />
                      <Typography variant="body2" className="lot-dropzone-text">Drag and drop here or click to upload a file.</Typography>
                      <Typography variant="caption" display="block" className="lot-dropzone-caption">Max file size: 2MB per image</Typography>
                      <Typography variant="caption" display="block" className="lot-dropzone-caption">Acceptable formats: .jpg, .jpeg, .png</Typography>
                    </Box>
                  </Paper>

                  {uploadedThumbnails.length > 0 && (
                    <Paper elevation={0} className="lot-paper-section lot-selected-thumbnails-section">
                      <Typography variant="subtitle1" gutterBottom className="lot-section-title">Selected thumbnails ({uploadedThumbnails.length}/{MAX_THUMBNAILS})</Typography>
                      <Grid container spacing={1}>
                        {uploadedThumbnails.map((thumb, index) => (
                          <Grid item key={index} className="lot-thumbnail-item">
                            <img src={thumb.image} alt={thumb.imageName} className="lot-thumbnail-img" />
                            <IconButton size="small" onClick={() => this.removeThumbnail(index)} className="lot-thumbnail-remove-btn">
                              <AddCircleOutlineIcon className="lot-thumbnail-remove-icon"/>
                            </IconButton>
                          </Grid>
                        ))}
                        {uploadedThumbnails.length < MAX_THUMBNAILS && (
                          <Grid item>
                            <Box 
                                onClick={this.triggerFileInput} 
                                className="lot-thumbnail-add-placeholder"
                            >
                                <AddCircleOutlineIcon className="lot-thumbnail-add-icon" />
                      </Box>
                          </Grid>
                        )}
                    </Grid>
                    </Paper>
                  )}

                  <Paper elevation={0} className="lot-paper-section lot-cycle-details-section">
                    <Typography variant="subtitle1" gutterBottom className="lot-section-title">Set up cycle details</Typography>
                    <Box component="fieldset" className="lot-fieldset">
                        <Typography component="legend" variant="caption" className="lot-legend">Rotation interval</Typography>
                        <Grid container spacing={1} className="lot-interval-presets">
                            {rotationIntervals.map(interval => (
                            <Grid item key={interval}>
                              <Button
                                    variant={rotationIntervalPreset === interval && !customRotationInterval ? 'contained' : 'outlined'} 
                                    onClick={() => this.handleRotationIntervalPreset(interval)}
                        size="small"
                                    className="lot-interval-btn"
                                >
                                {interval} min
                                </Button>
                            </Grid>
                            ))}
                        </Grid>
                      <TextField
                            label="Custom interval (min)" 
                            variant="outlined" 
                                      size="small"
                        type="number"
                            value={customRotationInterval}
                            onChange={this.handleCustomIntervalChange}
                            className="lot-custom-interval-input"
                            onClick={() => this.setState({ rotationIntervalPreset: null})}
                        />
                              </Box>
                    <Box component="fieldset" className="lot-fieldset">
                        <Typography component="legend" variant="caption" className="lot-legend">Repeat</Typography>
                        <TextField 
                            variant="outlined" 
                        size="small"
                                type="number"
                            value={rotationNumber}
                            onChange={this.handleRepeatChange}
                            InputProps={{ endAdornment: <Typography variant="body2" className="lot-repeat-adornment">times</Typography> }}
                            className="lot-repeat-input"
                        />
                    </Box>
                    <Typography variant="caption" className="lot-duration-text">The comparison cycle lasts {estimatedDuration}</Typography>
                  </Paper>

                  <Box className="lot-actions-section">
                    <Button 
                        variant="contained" 
                        onClick={this.handleStartRotationClick} 
                      disabled={uploadedThumbnails.length < 2 || (!customRotationInterval && !rotationIntervalPreset) || !rotationNumber || isStartingRotation}
                        className="lot-start-btn"
                    >
                      {isStartingRotation ? <CircularProgress size={24} color="inherit" /> : 'Start'}
                    </Button>
                    <Button variant="outlined" onClick={this.openScheduler} className="lot-schedule-btn">
                        Schedule
                    </Button>
                    {selectedDate && (
                        <Typography variant="caption" className="lot-scheduled-date-text">
                            Rotation set for {selectedDate.format('h:mm A on DD MMM, YYYY')}
                        </Typography>
                    )}
                  </Box>

                  <Dialog open={isSchedulerVisible} onClose={this.closeScheduler} maxWidth="xs" className="lot-scheduler-dialog">
                    <DialogTitle>Schedule rotation cycle</DialogTitle>
                    <DialogContent dividers>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            {schedulerStep === 1 ? (
                                <StaticDateTimePicker 
                                    displayStaticWrapperAs="desktop"
                                    openTo="day"
                                    value={tempSelectedDate}
                                    onChange={this.handleScheduleDateChange}
                                    minDateTime={dayjs()}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            ) : (
                          <MobileDateTimePicker
                                    label="Set rotation time"
                                    openTo="hours" 
                                    value={tempSelectedDate}
                                    onChange={this.handleScheduleDateChange}
                                    minDateTime={dayjs()} 
                            renderInput={(params) => <TextField {...params} />}
                          />
                            )}
                        </LocalizationProvider>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeScheduler}>Cancel</Button>
                        {schedulerStep === 1 ? (
                            <Button onClick={this.handleSchedulerNext}>Next</Button>
                        ) : (
                            <Button onClick={this.handleSchedulerSet}>Set</Button>
                        )}
                    </DialogActions>
                  </Dialog>
                </Box>
              </ThemeProvider>
            );
        }
    } else {
         return (
             <ThemeProvider theme={theme}>
                <Box className="lot-status-view no-video-selected">
                     <Typography variant="h6">Loading video details...</Typography>
                </Box>
                      </ThemeProvider>
         );
    }
  }
}

export default withCookies(ListOfThumbnails);
